var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolicyinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.167 4.167h1.666V5c0 .917.75 1.667 1.667 1.667h5c.917 0 1.667-.75 1.667-1.667v-.833h1.666v4.167H15.5V4.167c0-.917-.75-1.667-1.667-1.667H10.35A2.509 2.509 0 008 .833c-1.083 0-2 .7-2.35 1.667H2.167C1.25 2.5.5 3.25.5 4.167v11.666c0 .917.75 1.667 1.667 1.667h5v-1.666h-5V4.167zM8 2.5c.458 0 .833.375.833.833A.836.836 0 018 4.167a.836.836 0 01-.833-.833c0-.459.375-.834.833-.834z",
    fill: "inline"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 10.208a.89.89 0 00-1.25 0l-3.95 3.959-1.883-1.875a.89.89 0 00-1.25 0 .89.89 0 000 1.25l2.541 2.533a.83.83 0 001.175 0l4.609-4.617a.883.883 0 00.008-1.25z",
    fill: "inline"
  })));
}

export default SvgPolicyinline;